'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _media = require('./media.html');

var _media2 = _interopRequireDefault(_media);

var _media3 = require('./media.controller');

var _media4 = _interopRequireDefault(_media3);

require('./media.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediaComponent = {
  restrict: 'E',
  bindings: {},
  template: _media2.default,
  controller: _media4.default,
  controllerAs: 'vm'
};

exports.default = mediaComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/media/media.component.js
 **/